






























import { Component, Vue } from "vue-property-decorator";
import { purePcTmpCode } from "@/req/homes";

@Component({
  components: {},
})
export default class Home extends Vue {
  public code: any = "";
  public certificationData: any = {};
  public tip = "";
  public created() {
    this.tip = "请耐心等待，正在查询授权";
    if (this.$route.query.code) {
      this.code = this.$route.query.code;
      this.search();
    }
  }
  public async search(flag = false) {
    const res = await purePcTmpCode({
      code: this.code,
      // code: "971fcb786153f3bc134041hqaunaadru",
    });
    if (res.code == 200) {
      res.data.effect_start_at = res.data.effect_start_at.substring(0, 10);
      res.data.effect_end_at = res.data.effect_end_at.substring(0, 10);
      // res.data.code_expired_at = res.data.code_expired_at.substring(0, 10);
      this.certificationData = res.data
      this.$nextTick(() => {
        if (flag) {
          this.tip = "本次查询结果已过期，请重新查询";
          return;
        };
        setTimeout(() => {
          this.search(true);
        }, 310000);
      });
    } else {
      this.tip = res.msg;
      this.certificationData = {};
      this.$Message.error(res.msg);
    }
  }
}
